module.exports = __webpack_public_path__ + "img/logo_img1.8713d515.png";